import { render, staticRenderFns } from "./ListShow.vue?vue&type=template&id=5a4f2883&scoped=true&"
import script from "./ListShow.vue?vue&type=script&lang=ts&"
export * from "./ListShow.vue?vue&type=script&lang=ts&"
import style0 from "./ListShow.vue?vue&type=style&index=0&id=5a4f2883&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4f2883",
  null
  
)

export default component.exports